import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_USAGE_DETAILS: gql`
        query getMyUsageDetails($usageDetailsInput: UsageDetailsInput!) {
            getMyUsageDetails(usageDetailsInput: $usageDetailsInput) {
                usage {
                    first
                    last
                    number
                    numberOfElements
                    size
                    totalElements
                    totalPages
                    content {
                        amount
                        chargedNumber
                        chargeStartDateTime
                        destinationCarrierCode
                        destinationCountryCode
                        destinationNumber
                        general1
                        general2
                        general3
                        general4
                        general5
                        measuringUnit
                        originCountryCode
                        originNumber
                        quantity
                        roaming
                        roamingCarrierCode
                        roundedQuantity
                        terminating
                        trafficCategorization
                        usageCategory
                        usageId
                        usageType
                        usageTypeName
                    }
                }
            }
        }
    `,
    GET_USAGE_SUMMARY: gql`
        query getMyUsageSummary(
            $billingPeriod: String!
            $subscriptionType: String!
            $serviceId: Int!
        ) {
            getMyUsageSummary(
                billingPeriod: $billingPeriod
                subscriptionType: $subscriptionType
                serviceId: $serviceId
            ) {
                accountServiceId
                billPeriodEndDate
                billPeriodStartDate
                usageSummary {
                    amount
                    billable
                    eventCount
                    measuringUnit
                    quantity
                    roundedQuantity
                    usageCategory
                    usageType
                    usageTypeName
                }
            }
        }
    `,
};

/**
 * @name getUsageDetailsApi - calls usage details api and returns response
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {Object} Obj.usageDetailsInput - usageDetailsInput object
 * @param {String} Obj.usageDetailsInput.serviceId - service id for which usage details is being requested
 * @param {String} Obj.usageDetailsInput.subscriptionType - subscription type for which usage details is being requested
 * @param {String} Obj.usageDetailsInput.billingPeriod - billing period for which usage details is being requested
 * @param {String} Obj.usageDetailsInput.usageType - usage type for which usage details is being requested
 * @param {String} Obj.usageDetailsInput.page - page number of the response
 * @param {String} Obj.usageDetailsInput.size - page size of the response
 * @returns
 */
export const getUsageDetailsApi = async ({ graphql, usageDetailsInput }) => {
    try {
        const data = await graphql.query({
            query: ENDPOINT.GET_USAGE_DETAILS,
            variables: {
                usageDetailsInput,
            },
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

/**
 * @name getUsageSummaryApi - calls usage summary api and returns response
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {String} Obj.token - user access token
 * @param {String} Obj.billingPeriod - billing period for which usage summary is being requested
 * @param {String} Obj.subscriptionType - subscription type for which usage summary is being requested
 * @param {String} Obj.serviceId - service id for which usage summary is being requested
 * @returns
 */
export const getUsageSummaryApi = async ({
    graphql,
    token,
    billingPeriod,
    subscriptionType,
    serviceId,
}) => {
    try {
        const data = await graphql.query({
            query: ENDPOINT.GET_USAGE_SUMMARY,
            variables: {
                billingPeriod,
                subscriptionType,
                serviceId,
            },
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};
